export default class RequestError extends Error{
  readonly body: any;
  constructor(
    message:string,
    body:any
  ) {
    super(message);
    this.body = body;
  }
}